function toRoman(num: number): string {
  const lookup: [number, string][] = [
    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I'],
  ]
  let result = ''
  let remaining = num
  for (const [value, numeral] of lookup) {
    while (remaining >= value) {
      result += numeral
      remaining -= value
    }
  }
  return result.toLowerCase()
}

interface PageNumberProps {
  number: number
}

export function PageNumber({ number }: PageNumberProps) {
  return (
    <p className="text-center text-xs text-gold mt-lg">
      — {toRoman(number)} —
    </p>
  )
}
